import React, { useState } from "react";
import Auth from "../../components/Auth/Auth";
import "./Register.scss";
import { useRegister } from "./logic/useRegister";
import { Spin } from "antd";
import { Radio } from 'antd';

function Register() {
  const { handleSubmit, register, errors, onSubmit, loading, getValues } = useRegister();
  const options = [
    {
      label: 'Site Member',
      value: 'siteMember',
    },
    {
      value: "Trainer",
      label: "Trainer",
    },
    {
      label: 'Team leader',
      value: 'teamLeader',
      },
    {
      label: 'Division Manager',
      value: 'divisionManager',
    },
    {
      label: 'Porject Manager',
      value: 'projectmanager',
    },
  ];
  const [value1, setValue1] = useState('Apple');
  const onChange1 = ({ target: { value } }) => {
    console.log('radio1 checked', value);
    setValue1(value);
  };

  return (
    <div className="registerPage">
      <Auth title={"Register"} handleSubmitForm={handleSubmit(onSubmit)}>
        <div className="register-form-control">
          {loading && <Spin size="large" />}

          <div className="register-form-control-username">
            <div className="user-firstname">
              <label>First Name</label>
              <input
                type="text"
                placeholder="First Name"
                {...register("firstName", {
                  required: "First Name is required",
                })}
              />
              {errors.firstName && (
                <p className="error">{errors.firstName.message}</p>
              )}
            </div>
            <div className="user-lastname">
              <label>Last Name</label>
              <input
                type="text"
                placeholder="Last Name"
                {...register("lastName", { required: "Last Name is required" })}
              />
              {errors.lastName && (
                <p className="error">{errors.lastName.message}</p>
              )}
            </div>
          </div>
        </div>
         <div className="register-form-control-accounttype">
            <label>Account Type</label>
            <div className="radio-group">
            <Radio.Group  options={options} onChange={onChange1} value={value1} optionType="button" />
            </div>
          </div>
        <div className="register-form-control">
          <label>Email Address</label>
          <input
            type="text"
            placeholder="Your email address"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i,
                message: "Invalid email address",
              },
              validate: {
                notAdmin: (fieldValue) => {
                  if (fieldValue.includes("admin")) {
                    return "Email address cannot contain 'admin'. Please enter a different email address.";
                  }
                  return true;
                },
                notBlackListed: (fieldValue) => {
                  return (
                    !fieldValue.endsWith("avaxia-group.com") ||
                    "This domain is for SSO use only"
                  );
                },
              },
            })}
          />
          {errors.email && <p className="error">{errors.email.message}</p>}
        </div>

        <div className="register-form-control">
          <label>Password</label>
          <input
            type="password"
            placeholder="Your password"
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters long",
              },
            })}
          />
          {errors.password && (
            <p className="error">{errors.password.message}</p>
          )}
        </div>

        <div className="register-form-control">
          <label>Confirm Password</label>
          <input
            type="password"
            placeholder="Confirm your password"
            {...register("confirmPassword", {
              required: "Confirm Password is required",
              minLength: {
                value: 8,
                message: "Phone number must be at least 8 characters long",
              },
              validate: (value) =>
                value === getValues("password") || "Passwords do not match",
            })}
          />
          {errors.confirmPassword && (
            <p className="error">{errors.confirmPassword.message}</p>
          )}
        </div>

        <div className="register-form-control">
          <label>Phone Number</label>
          <input
            type="tel"
            placeholder="Your phone number"
            {...register("telephone", {
              required: "Phone number is required",
              // pattern: {
              //   value: /^\d{8,12}$/,
              //   message: "Invalid phone number",
              // },
              pattern: {
                value: /^(?:\+\d{1,3}|00\d{1,3})?\d{8}$/,
                message: "Phone number must be in the format 12345678, +xxx12345678, or 00xxx12345678 and should not exceed 11 digits."
              },
              validate: (value) => {
                if (
                  value &&
                  /^(?:\+\d{1,3}|00\d{1,3})\d{7}$/.test(value)
                ) {
                  return "Invalid phone number format, must be in the format +xxx12345678 or 00xxx12345678.";
                }
                return true;
              }
            })}
          />
          {errors.telephone && (
            <p className="error">{errors.telephone.message}</p>
          )}
        </div>
      </Auth>
    </div>
  );
}

export default Register;
